import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import BatteryChargingFullIcon from "@mui/icons-material/BatteryChargingFull";

export const serviceTab = [
  {
    key: "cash_collection",
    route: "/cash-collection",
    title: "Cash Collection",
    description:
      "Track and manage cash pickups with real-time reports and automation.",
    icon: <CheckCircleIcon fontSize="inherit" />,
    bgColor:
      "linear-gradient(135deg,rgb(37, 190, 190) 0%, #16a085 50%, #0f7a6b 100%)",
    buttonText: "Start Collection",
    buttonColor:
      "linear-gradient(90deg,  rgb(37, 190, 190) 0%, #16a085 50%, #0f7a6b 100%)",
    statusDot: "#2ECC71",
  },
  {
    key: "manual_swap",
    route: "/manual-swap",
    title: "Manual Swap",
    description:
      "Perform quick battery swaps with guided steps and full visibility.",
    icon: <SwapHorizIcon fontSize="inherit" />,
    bgColor: "linear-gradient(135deg, #1DA7A7 0%, #26d0ce 50%, #00b4d8 100%)",
    buttonText: "Initiate Swap",
    buttonColor:
      "linear-gradient(90deg, #1DA7A7 0%, #26d0ce 50%, #00b4d8 100%)",
    statusDot: "#2ECC71",
  },
  {
    key: "battery_movement",
    route: "/battery-movement",
    title: "Battery Movement",
    description: "Track battery transfers across states with live updates.",
    icon: <BatteryChargingFullIcon fontSize="inherit" />,
    bgColor: "linear-gradient(135deg, #1DA7A7 0%, #48cae4 50%, #90e0ef 100%)",
    buttonText: "Track Movement",
    buttonColor:
      "linear-gradient(90deg, #1DA7A7 0%, #48cae4 50%, #90e0ef 100%)",
    statusDot: "#F39C12",
  },
];
